import React, { useEffect, useState } from "react";
import Icon_L from "../../assets/images/Icon_L.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { baseUrl } from "../../utils/baseUrl";
import axios from "axios";
import {
  IMeansOfIdentification,
  IEmploymentInfo,
  IAccountMandate,
  Icurrency,
  ICountry,
} from "../../models/IEnums.model";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { formatBVNDate } from "../../utils/formatDate";
import { MultiSelect } from "react-multi-select-component";
import IdCardSample from "../IdCardSample";
import { statesInNigeria } from "../../utils/constants";
import * as toast from "../../utils/makeToast";

function UpdateDetailJointCurrentDialog(props: any) {
  const dispatch = useDispatch();

  const [updating, setUpdating] = useState(false);

  const [meansOfIdentification, setMeansOfIdentification] = useState<
    IMeansOfIdentification[]
  >([]);
  const [employmentInfos, setEmploymentInfos] = useState<IEmploymentInfo[]>([]);
  const [jointAccountMandate, setJointAccountMandate] = useState<
    IAccountMandate[]
  >([]);
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [idCardtype, setIdCardType] = useState<any>(1);
  const [secondaryIdCardtype, setSecondaryIdCardType] = useState<any>(1);

  const [currencies, setCurrencies] = useState<Icurrency[]>([]);

  const [selected, setSelected] = useState<any>([]);
  const [mappedCurrencies, setMappedCurrencies] = useState([]);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [todaysDate, setTodaysDate] = useState<any>(
    new Date().toISOString().split("T")[0]
  );

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  const formik = useFormik({
    initialValues: {
      passport: "",
      firstName: userDetails.firstName,
      secondName: userDetails.middleName,
      lastName: userDetails.lastName,
      dateOfBirth: formatBVNDate(userDetails.dateOfBirth),
      identityCardType: "",
      idCardNumber: "",
      issueDate: "",
      expiryDate: "",
      nextOfKin: "",
      selfEmployementInformation: "",
      secondSignatoryPassport: "",
      secondSignatoryFirstName: "",
      secondSignatorySecondName: "",
      secondSignatoryLastName: "",
      secondSignatoryDateOfBirth: "",
      secondSignatoryIdentityCardType: "",
      secondSignatoryIDCardNumber: "",
      secondSignatoryIssueDate: "",
      secondSignatoryExpiryDate: "",
      secondSignatoryNextOfKin: "",
      secondSignatorySelfEmployementInformation: 0,
      jointPhoneNumber: "",
      jointAccountName: "",
      jointEmailAddress: "",
      currencyOfAccountUSD: "",
      currencyOfAccountGBP: "",
      currencyOfAccountNAIRA: "",
      currencyOfAccountEURO: "",
      jointAccountMandate: "",
      specifyMandate: "",
      houseNumber: "",
      streetName: "",
      areaState: "",
      nearestBustopLandmark: "",
      address: "",
      referralCode: "",

      secondBvn: "",

      nationality: "",

      // firstFirstName: userDetails.firstName,
      // firstSecondName: userDetails.middleName,
      // firstLastName: userDetails.lastName,
      // firstDateOfBirth: formatBVNDate(userDetails.dateOfBirth),
      // firstIdentityCardType: "",
      // firstIdCardNumber: "",
      // firstIssueDate: "",
      // firstExpiryDate: "",
      // firstSelfEmploymentInformation: "",
      // firstNextOfKin: "",

      // secondBvn: "",
      // secondFirstName: "",
      // secondSecondName: "",
      // secondLastName: "",
      // secondDateOfBirth: "",
      // secondIdentityCardType: "",
      // secondIdCardNumber: "",
      // secondIssueDate: "",
      // secondExpiryDate: "",
      // secondSelfEmploymentInformation: "",
      // secondNextOfKin: "",

      // jointAccountName: "",
      // jointPhoneNumber: "",
      // jointEmailAddress: "",
      // jointAccountMandate: "",
      // jointMandateOthers: "",

      // houseNumber: "",
      // streetName: "",
      // areaState: "",
      // nearestBustopLandmark: "",
      // address: "",
      // referralCode: "",
      // accountCurrencies: ""
    },
    // validationSchema: Yup.object({
    //     firstIdCardNumber: Yup.string().required("ID card number is required"),
    //     // firstIssueDate: Yup.string().required("Issue date is required"),
    //     // firstExpiryDate: Yup.string().required("Expiry date is required"),

    //     secondBvn: Yup.string().required("BVN is required"),
    //     secondFirstName: Yup.string().required("Firstname is required"),
    //     secondLastName: Yup.string().required("Lastname is required"),
    //     secondDateOfBirth: Yup.string().required("Date of birth is required"),
    //     secondIdCardNumber: Yup.string().required("ID card number is required"),
    //     // secondIssueDate: Yup.string().required("Issue date is required"),
    //     // secondExpiryDate: Yup.string().required("Expiry date is required"),

    //     jointAccountName: Yup.string().required("Account Name is required"),
    //     jointPhoneNumber: Yup.string().required("Phone Number is required"),
    //     jointEmailAddress: Yup.string().email("Invalid email").required("Email is required"),
    //     jointAccountMandate: Yup.string().required("Please select a mandate"),

    //     address: Yup.string().required("Address is required")

    // }),
    validationSchema: Yup.object({
      idCardNumber: Yup.string().required("ID card number is required"),
      // firstIssueDate: Yup.string().required("Issue date is required"),
      // firstExpiryDate: Yup.string().required("Expiry date is required"),

      secondBvn: Yup.string().required("BVN is required"),
      secondSignatoryFirstName: Yup.string().required("Firstname is required"),
      secondSignatoryLastName: Yup.string().required("Lastname is required"),
      secondSignatoryDateOfBirth: Yup.string().required(
        "Date of birth is required"
      ),
      secondSignatoryIDCardNumber: Yup.string().required(
        "ID card number is required"
      ),
      // secondIssueDate: Yup.string().required("Issue date is required"),
      // secondExpiryDate: Yup.string().required("Expiry date is required"),

      jointAccountName: Yup.string().required("Account Name is required"),
      jointPhoneNumber: Yup.string().required("Phone Number is required"),
      jointEmailAddress: Yup.string()
        .email("Invalid email")
        .required("Email is required"),
      jointAccountMandate: Yup.string().required("Please select a mandate"),

      address: Yup.string().required("Address is required"),
      nationality: Yup.string().required("Nationality is required"),
    }),
    onSubmit: (values) => {
      updateDetails(values);
    },
  });

  // const updateDetails = (values: any) => {
  //   let updateDetailsPayload = {
  //     ...values,
  //     primaryIdentityCardType: +idCardtype,
  //     secondaryIdentityCardType: +secondaryIdCardtype,
  //     // jointAccountMandate: +values.jointAccountMandate,
  //     bvn: userDetails.bvn
  //   }
  //   // return
  //   setUpdating(true)
  //   axios.post(`${baseUrl}JointCurrent/JointCurrentDetails`, updateDetailsPayload)
  //     .then((response) => {
  //       setUpdating(false)
  //       // disatch(setAccountOpeningStep('document-upload'))
  //     })
  //     .catch((err) => {
  //       setUpdating(false)
  //     })
  // }

  const updateDetails = (values: any) => {
    let updateDetailsPayload = {
      ...values,
      identityCardType: +idCardtype,
      secondSignatoryIdentityCardType: +secondaryIdCardtype,

      selfEmployementInformation: +values.selfEmployementInformation,
      secondSignatorySelfEmployementInformation:
        +values.secondSignatorySelfEmployementInformation,

      bvn: userDetails.bvn,

      currencyOfAccountUSD: "",
      currencyOfAccountGBP: "",
      currencyOfAccountEURO: "",
      currencyOfAccountNAIRA: "",
    };

    /////
    if (selected.find((x: any) => x.value == "GBP")) {
      updateDetailsPayload.currencyOfAccountGBP = "GBP";
    }
    if (selected.find((x: any) => x.value == "EUR")) {
      updateDetailsPayload.currencyOfAccountEURO = "EUR";
    }
    if (selected.find((x: any) => x.value == "USD")) {
      updateDetailsPayload.currencyOfAccountUSD = "USD";
    }
    if (selected.find((x: any) => x.value == "NGN")) {
      updateDetailsPayload.currencyOfAccountNAIRA = "NGN";
    }
    /////

    
    
    setLocalStorageItem(
      "update-details-page-user-data",
      JSON.stringify(updateDetailsPayload)
    );
    // return
    setUpdating(true);
    axios
      .post(`${baseUrl}JointCurrent/JointCurrentDetails`, updateDetailsPayload)
      .then((response) => {
        
        setUpdating(false);
        dispatch(setAccountOpeningStep("document-upload"));
      })
      .catch((err) => {
        // 
        setUpdating(false);
      });
  };

  const getEmploymentInfo = () => {
    axios
      .get(`${baseUrl}Enum/EmployementInfo`)
      .then((response) => {
        setEmploymentInfos(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getMeansOfIdentification = () => {
    axios
      .get(`${baseUrl}Enum/MeansOfIdentification`)
      .then((response) => {
        setMeansOfIdentification(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getJointAccountMandates = () => {
    axios
      .get(`${baseUrl}Enum/JointAccountMandate`)
      .then((response) => {
        setJointAccountMandate(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getCurrencies = () => {
    axios
      .get(`${baseUrl}Enum/Currency`)
      .then((response) => {
        let tempCurrencies = [];
        tempCurrencies = response.data.map((currency: Icurrency) => {
          return {
            label: currency.lonG_DESC_ENG,
            value: currency.brieF_DESC_ENG,
          };
        });
        setMappedCurrencies(tempCurrencies);
        setCurrencies(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getCountries = () => {
    axios
      .get(`${baseUrl}Enum/Country`)
      .then((response) => {
        let nigeria = response?.data.find(
          (x) => x.lonG_DESC_ENG.toLowerCase() === "nigeria"
        );
        let otherCountries = response?.data.filter(
          (x) => x.lonG_DESC_ENG.toLowerCase() !== "nigeria"
        );
        let countries = [nigeria, ...otherCountries];
        setCountries(countries);
      })
      .catch((err) => {
        
      });
  };

  const handleSetIdCardType = (id: any) => {
    setIdCardType(id);
  };

  const handleSetSecondaryIdCardType = (id: any) => {
    setSecondaryIdCardType(id);
  };

  useEffect(() => {
    getMeansOfIdentification();
    getEmploymentInfo();
    getJointAccountMandates();
    getCurrencies();
    getCountries();
  }, []);

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const handleCurrencySelectionChange = (selectedItems) => {
    if (selectedItems.length > 1) {
      console.error("Sorry, choose only one item.");
      toast.errorToast(
        "You can only select one foreign currency account at a time. Please choose a single currency to proceed."
      );

      return;
    }
    setSelected(selectedItems);
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="card-body">
          <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
          <p className="text-center pl-5 no-wrap">
            Hello{" "}
            <span className="font-weight-bold">
              <b>{userDetails.firstName},</b>{" "}
            </span>
            Welcome to Sterling Alternative Finance
          </p>
          <div className="bvn_val mb-4" id="fader">
            <img src={Icon_L} alt="" />
            <small className="text-danger ml-4 font-weight-bold">
              <b>Update your address and email if it has changed</b>
            </small>
          </div>
          <div className="row">
            <div className="col-sm-4 mt-4">
              <small className="label_text">First signatory</small>
              <div className="col-12 pic_upload3 label_text3 text-nowrap">
                Photo
              </div>
            </div>

            <div className="col-sm-8 mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="firstName"
                    value={userDetails.firstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Tunde"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Secondname
                  </label>
                  <input
                    name="secondName"
                    value={userDetails.middleName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Emeka"
                    disabled
                  />
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Lastname
                  </label>
                  <input
                    name="lastName"
                    value={userDetails.lastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Aminah"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="dob"
                    max={todaysDate}
                    value={userDetails.dateOfBirth}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="12-04-1989"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="idcardtype" className="label_text my-2">
              Select identity card type
            </label>

            <ul
              className="nav nav-pills identity-tab mb-3 nav-fill"
              id="pills-tab"
              role="tablist"
            >
              {meansOfIdentification.map(
                (identification: IMeansOfIdentification) => {
                  return (
                    <li
                      className="nav-item"
                      key={identification.id}
                      onClick={() => handleSetIdCardType(identification.id)}
                    >
                      <a
                        className={`nav-link text-nowrap pl-0 pt-2 ${
                          identification.id == 1 ? "active" : ""
                        }`}
                        id="pills-int-tab"
                        data-toggle="pill"
                        href="#pills-int"
                        role="tab"
                        aria-controls="pills-int"
                        aria-selected="true"
                      >
                        {identification.text}
                      </a>
                    </li>
                  );
                }
              )}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextofkin"
                        className="label_text mb-2"
                        data-bs-toggle="modal"
                        data-bs-target="#idCardSampleModal"
                      >
                        ID card number{" "}
                        <i className="bx bxs-info-circle cursor-pointer"></i>
                      </label>
                      <input
                        name="idCardNumber"
                        onChange={formik.handleChange}
                        value={formik.values.idCardNumber}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter ID card number"
                      />
                      {formik.touched.idCardNumber &&
                      formik.errors.idCardNumber ? (
                        <small className="text-danger">
                          {formik.errors.idCardNumber}
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group identity">
                      <label htmlFor="issueDate" className="label_text mb-2">
                        Issue Date
                      </label>
                      <input
                        name="issueDate"
                        max={todaysDate}
                        onChange={formik.handleChange}
                        value={formik.values.issueDate}
                        type="date"
                        className="form-control border-dark bg-white"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>

                  {(idCardtype == 2 || idCardtype == 4) && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expiryDate" className="label_text mb-2">
                          Expiry Date
                        </label>
                        <input
                          name="expiryDate"
                          min={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.expiryDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="nextofkin" className="label_text">
                    Name of next of kin
                  </label>
                  <input
                    name="nextOfKin"
                    onChange={formik.handleChange}
                    value={formik.values.nextOfKin}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter name of next of kin"
                  />
                </div>
                <div className="col-lg-6 form-group">
                  <label htmlFor="employmentinformation" className="label_text">
                    Select employment information
                  </label>
                  <select
                    name="selfEmployementInformation"
                    onChange={formik.handleChange}
                    value={formik.values.selfEmployementInformation}
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    <option value="">Select employment information</option>
                    {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
                      return (
                        <option
                          key={employmentInfo.id}
                          value={employmentInfo.id}
                        >
                          {employmentInfo.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3 mb-4">
            <div className="col form-group">
              <label htmlFor="nationality" className="label_text">
                Nationality
              </label>
              <select
                name="nationality"
                onChange={formik.handleChange}
                value={formik.values.nationality}
                className="form-control border-dark"
              >
                <option value="">Select nationality</option>
                {countries.map((country: ICountry) => {
                  return (
                    <option key={country.id} value={country.countrY_CODE}>
                      {country.lonG_DESC_ENG}
                    </option>
                  );
                })}
              </select>
              {formik.touched.nationality && formik.errors.nationality ? (
                <small className="text-danger">
                  {formik.errors.nationality}
                </small>
              ) : null}
            </div>
          </div>

          <div className="form-group mt-4">
            <label
              htmlFor="idcardtype"
              className="label_text font-weight-bold mb-3"
            >
              <b>Second signatory</b>
            </label>
            <div className="d-flex justify-content-between pb-1 fillup">
              <label htmlFor="name" className="fila">
                Enter BVN (of secondary signatory)
              </label>
              <i
                className="bx bxs-info-circle"
                data-toggle="tooltip"
                data-placement="bottom"
                title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
              ></i>
            </div>
            <input
              name="secondBvn"
              onChange={formik.handleChange}
              value={formik.values.secondBvn}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="bvn"
              placeholder="Enter your BVN"
            />
            {formik.touched.secondBvn && formik.errors.secondBvn ? (
              <small className="text-danger">{formik.errors.secondBvn}</small>
            ) : null}
          </div>

          <div className="row">
            <div className="col-sm-4 mt-4">
              <br />
              <div className="col-12 pic_upload3 label_text3 text-nowrap">
                Photo
              </div>
            </div>

            <div className="col-sm-8 mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="secondSignatoryFirstName"
                    onChange={formik.handleChange}
                    value={formik.values.secondSignatoryFirstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondSignatoryFirstName &&
                  formik.errors.secondSignatoryFirstName ? (
                    <small className="text-danger">
                      {formik.errors.secondSignatoryFirstName}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Secondname
                  </label>
                  <input
                    name="secondSignatorySecondName"
                    onChange={formik.handleChange}
                    value={formik.values.secondSignatorySecondName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondSignatorySecondName &&
                  formik.errors.secondSignatorySecondName ? (
                    <small className="text-danger">
                      {formik.errors.secondSignatorySecondName}
                    </small>
                  ) : null}
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Lastname
                  </label>
                  <input
                    name="secondSignatoryLastName"
                    onChange={formik.handleChange}
                    value={formik.values.secondSignatoryLastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondSignatoryLastName &&
                  formik.errors.secondSignatoryLastName ? (
                    <small className="text-danger">
                      {formik.errors.secondSignatoryLastName}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="secondSignatoryDateOfBirth"
                    max={todaysDate}
                    onChange={formik.handleChange}
                    value={formik.values.secondSignatoryDateOfBirth}
                    type="date"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.secondSignatoryDateOfBirth &&
                  formik.errors.secondSignatoryDateOfBirth ? (
                    <small className="text-danger">
                      {formik.errors.secondSignatoryDateOfBirth}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="idcardtype" className="label_text mb-3">
              Select identity card type
            </label>

            <ul
              className="nav nav-pills identity-tab mb-3 nav-fill"
              id="pills-tab"
              role="tablist"
            >
              {meansOfIdentification.map(
                (identification: IMeansOfIdentification) => {
                  return (
                    <li
                      className="nav-item"
                      key={identification.id}
                      onClick={() =>
                        handleSetSecondaryIdCardType(identification.id)
                      }
                    >
                      <a
                        className={`nav-link text-nowrap pl-0 pt-2 ${
                          identification.id == 1 ? "active" : ""
                        }`}
                        id="pills-int-tab"
                        data-toggle="pill"
                        href="#pills-int"
                        role="tab"
                        aria-controls="pills-int"
                        aria-selected="true"
                      >
                        {identification.text}
                      </a>
                    </li>
                  );
                }
              )}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int2"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="nextofkin"
                        className="label_text mb-2"
                        data-bs-toggle="modal"
                        data-bs-target="#idCardSampleModal"
                      >
                        ID card number{" "}
                        <i className="bx bxs-info-circle cursor-pointer"></i>
                      </label>
                      <input
                        name="secondSignatoryIDCardNumber"
                        onChange={formik.handleChange}
                        value={formik.values.secondSignatoryIDCardNumber}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter ID card number"
                      />
                      {formik.touched.secondSignatoryIDCardNumber &&
                      formik.errors.secondSignatoryIDCardNumber ? (
                        <small className="text-danger">
                          {formik.errors.secondSignatoryIDCardNumber}
                        </small>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group identity">
                      <label htmlFor="issuedate" className="label_text mb-2">
                        Issue Date
                      </label>
                      <input
                        name="secondSignatoryIssueDate"
                        max={todaysDate}
                        onChange={formik.handleChange}
                        value={formik.values.secondSignatoryIssueDate}
                        type="date"
                        className="form-control border-dark bg-white"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>

                  {(secondaryIdCardtype == 2 || secondaryIdCardtype == 4) && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="expirydate" className="label_text mb-2">
                          Expiry Date
                        </label>
                        <input
                          name="secondSignatoryExpiryDate"
                          min={todaysDate}
                          onChange={formik.handleChange}
                          value={formik.values.secondSignatoryExpiryDate}
                          type="date"
                          className="form-control border-dark bg-white"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="nextofkin" className="label_text">
                    Name of next of kin
                  </label>
                  <input
                    name="secondSignatoryNextOfKin"
                    onChange={formik.handleChange}
                    value={formik.values.secondSignatoryNextOfKin}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter name of next of kin"
                  />
                </div>
                <div className="col-lg-6 form-group">
                  <label
                    htmlFor="employmentinformation"
                    className="label_text text-nowrap"
                  >
                    Select employment information
                  </label>
                  <select
                    name="secondSignatorySelfEmployementInformation"
                    onChange={formik.handleChange}
                    value={
                      formik.values.secondSignatorySelfEmployementInformation
                    }
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
                      return (
                        <option
                          key={employmentInfo.id}
                          value={employmentInfo.id}
                        >
                          {employmentInfo.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-4">
            <label
              htmlFor="idcardtype"
              className="label_text font-weight-bold mb-3"
            >
              <b>Joint account information</b>
            </label>
            <div className="d-flex justify-content-between pb-2 fillup">
              <label htmlFor="name" className="label_text pb-1">
                Joint account name
              </label>
            </div>
            <input
              name="jointAccountName"
              onChange={formik.handleChange}
              value={formik.values.jointAccountName}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="bvn"
              placeholder=""
            />
            {formik.touched.jointAccountName &&
            formik.errors.jointAccountName ? (
              <small className="text-danger">
                {formik.errors.jointAccountName}
              </small>
            ) : null}
          </div>

          <div className="row mt-4">
            <div className="col sec">
              <div className="row form-row mb-4">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="phonenumber" className="label_text">
                    Joint account phone number
                  </label>
                  <input
                    name="jointPhoneNumber"
                    onChange={formik.handleChange}
                    value={formik.values.jointPhoneNumber}
                    type="text"
                    className="form-control border-dark bg-white"
                    placeholder="0801 2345 678"
                  />
                  {formik.touched.jointPhoneNumber &&
                  formik.errors.jointPhoneNumber ? (
                    <small className="text-danger">
                      {formik.errors.jointPhoneNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="email" className="label_text">
                    {" "}
                    Joint account email address
                  </label>
                  <input
                    name="jointEmailAddress"
                    onChange={formik.handleChange}
                    value={formik.values.jointEmailAddress}
                    type="email"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                  {formik.touched.jointEmailAddress &&
                  formik.errors.jointEmailAddress ? (
                    <small className="text-danger">
                      {formik.errors.jointEmailAddress}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="form-group mb-4">
            <label htmlFor="branch domicilation" className="label_text">Currencies of account to be
              opened</label>
            <select name="accountCurrencies" onChange={formik.handleChange} value={formik.values.accountCurrencies} className="form-control border-dark bg-white" id="">
              <option value="">Select currency</option>
              {currencies.map((currency: Icurrency) => {
                return (
                  <option key={currency.id} value={currency.id}>{currency.brieF_DESC_ENG}</option>
                )
              })}
            </select>
          </div> */}

          <div className="form-group mb-4">
            <label htmlFor="branch domicilation" className="label_text">
              Currencies of account to be opened
            </label>
            <MultiSelect
              options={mappedCurrencies}
              value={selected}
              // onChange={setSelected}
              onChange={handleCurrencySelectionChange}
              labelledBy="Select"
              hasSelectAll={false}
            />
          </div>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-2">
                <div className="col-lg-6 form-group mr-2">
                  <label htmlFor="employmentinformation" className="label_text">
                    Select joint account mandate
                  </label>
                  <select
                    name="jointAccountMandate"
                    onChange={formik.handleChange}
                    value={formik.values.jointAccountMandate}
                    onBlur={formik.handleBlur}
                    className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
                    id="box"
                  >
                    <option value="">Select employment information</option>
                    {jointAccountMandate.map((mandate: IAccountMandate) => {
                      return (
                        <option key={mandate.id} value={mandate.id}>
                          {mandate.mandate}
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.jointAccountMandate &&
                  formik.errors.jointAccountMandate ? (
                    <small className="text-danger">
                      {formik.errors.jointAccountMandate}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="specifymandate" className="label_text">
                    Specify Mandate (for others)
                  </label>
                  <input
                    name="jointMandateOthers"
                    onChange={formik.handleChange}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>

          <label
            htmlFor="residentialaddress"
            className="label_text mb-2 font-weight-bold"
          >
            Residential address
          </label>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*" // This pattern allows only numeric characters
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    Area/State
                  </label>
                  <select
                    name="areaState"
                    onChange={formik.handleChange}
                    value={formik.values.areaState}
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value="">Select state</option>
                    {statesInNigeria.map((state: any) => {
                      return (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Nearest bus-top/landmark
                  </label>
                  <input
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mb-4">
            <label htmlFor="address" className="label_text">
              Address
            </label>
            <input
              name="address"
              onChange={formik.handleChange}
              value={formik.values.address}
              className="form-control sec border-dark"
              type="text"
              id="address"
              placeholder="No 12 Bode Thomas Masha round about Lagos"
            />
            {formik.touched.address && formik.errors.address ? (
              <small className="text-danger">{formik.errors.address}</small>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="refferalcode" className="label_text">
              DAO/Referral code(optional)
            </label>
            <input
              name="referralCode"
              onChange={formik.handleChange}
              value={formik.values.referralCode}
              className="form-control border-dark"
              type="text"
              id="name"
              placeholder="Enter referral code"
            />
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={() => {
                goToStep("bvn-validation");
              }}
              style={{ marginRight: "10px" }}
              className="btn btn-outline-danger mr-3 btn-filled-white"
            >
              Previous
            </button>
            {updating ? (
              <div className="spinner-border text-danger" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button type="submit" className="btn btn-danger btn-filled-red">
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>

      {/*  */}
      <div
        className="modal fade"
        id="idCardSampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <IdCardSample idCardType={idCardtype} />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );

  // return (
  //     <div>

  //       <form onSubmit={formik.handleSubmit}>

  //       <div className="card-body">
  //           <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
  //           <p className="text-center pl-5 no-wrap">Hello <span className="font-weight-bold"><b>{userDetails.firstName},</b> </span>
  //               Welcome to Sterling Alternative Finance
  //           </p>
  //           <div className="bvn_val mb-4" id="fader">
  //             <img src={Icon_L} alt="" />
  //             <small className="text-danger ml-4 font-weight-bold"><b>Update your address and email if it has changed</b></small>
  //           </div>
  //           <div className="row">
  //             <div className="col-sm-4 mt-4">
  //               <small className="label_text">First signatory</small>
  //               <div className="col-12 pic_upload3 label_text3 text-nowrap">Photo</div>
  //             </div>

  //             <div className="col-sm-8 mt-4 pt-2 sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 sec">
  //                   <label htmlFor="firstname" className="label_text">Firstname</label>
  //                   <input name="firstName" value={userDetails.firstName} type="text" className="form-control bg-white border-dark" placeholder="Tunde" disabled />
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="secondname" className="label_text">Secondname</label>
  //                   <input name="secondName" value={userDetails.middleName} type="text" className="form-control bg-white border-dark" placeholder="Emeka" disabled />
  //                 </div>
  //               </div>
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6">
  //                   <label htmlFor="lastname" className="label_text">Lastname</label>
  //                   <input name="lastName" value={userDetails.lastName} type="text" className="form-control bg-white border-dark" placeholder="Aminah" disabled />
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="dateofbirth" className="label_text">Date of birth</label>
  //                   <input name="dob" value={userDetails.dateOfBirth} type="text" className="form-control bg-white border-dark" placeholder="12-04-1989" disabled />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group">
  //             <label htmlFor="idcardtype" className="label_text my-2">Select identity card type</label>

  //             <ul className="nav nav-pills identity-tab mb-3 nav-fill" id="pills-tab" role="tablist">
  //               {meansOfIdentification.map((identification: IMeansOfIdentification) => {
  //                 return (
  //                   <li className="nav-item" key={identification.id} onClick={() => handleSetIdCardType(identification.id)}>
  //                     <a className={`nav-link text-nowrap pl-0 pt-2 ${identification.id == 1 ? "active" : ""}`} id="pills-int-tab" data-toggle="pill"
  //                       href="#pills-int" role="tab" aria-controls="pills-int" aria-selected="true">{identification.text}</a>
  //                   </li>
  //                 )
  //               })}
  //             </ul>
  //             <div className="tab-content" id="pills-tabContent">
  //               <div className="tab-pane show fade active" id="pills-int" role="tabpanel" aria-labelledby="pills-int-tab">
  //                 <div className="row mb-4">
  //                   <div className="col-md-6">
  //                     <div className="form-group">
  //                       <label htmlFor="nextofkin" className="label_text">ID card number</label>
  //                       <input name="firstIdCardNumber" onChange={formik.handleChange} value={formik.values.firstIdCardNumber} className="form-control border-dark" type="text" id="name"
  //                         placeholder="Enter ID card number" />
  //                       {formik.touched.firstIdCardNumber && formik.errors.firstIdCardNumber ? <small className="text-danger">{formik.errors.firstIdCardNumber}</small> : null}
  //                     </div>
  //                   </div>
  //                   <div className="col-md-3">
  //                     <div className="form-group identity">
  //                       <label htmlFor="issuedate" className="label_text">Issue Date</label>
  //                       <input name="firstIssueDate" onChange={formik.handleChange} value={formik.values.firstIssueDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" />
  //                     </div>

  //                   </div>
  //                   <div className="col-md-3">
  //                     <div className="form-group">
  //                       <label htmlFor="expirydate" className="label_text">Expiry Date</label>
  //                       <input name="firstExpiryDate" onChange={formik.handleChange} value={formik.values.firstExpiryDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" />
  //                     </div>

  //                   </div>
  //                 </div>

  //               </div>

  //             </div>

  //           </div>

  //           <div className="row">
  //             <div className="col sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 mr-2">
  //                   <label htmlFor="nextofkin" className="label_text">Name of next of kin</label>
  //                   <input name="firstNextOfKin" onChange={formik.handleChange} value={formik.values.firstNextOfKin} type="text" className="form-control bg-white border-dark"
  //                     placeholder="Enter name of next of kin"  />
  //                 </div>
  //                 <div className="col-lg-6 form-group">
  //                   <label htmlFor="employmentinformation" className="label_text">Select employment information</label>
  //                   <select name="firstSelfEmploymentInformation" onChange={formik.handleChange} value={formik.values.firstSelfEmploymentInformation} onBlur={formik.handleBlur} className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3" id="box">
  //                     <option value="">Select employment information</option>
  //                     {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
  //                       return (
  //                         <option key={employmentInfo.id} value={employmentInfo.id}>{employmentInfo.name}</option>
  //                       )
  //                     })}
  //                   </select>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group mt-4">
  //             <label htmlFor="idcardtype" className="label_text font-weight-bold mb-3"><b>Second signatory</b></label>
  //             <div className="d-flex justify-content-between pb-1 fillup">
  //               <label htmlFor="name" className="fila">Enter BVN (of secondary signatory)</label>
  //               <i className='bx bxs-info-circle' data-toggle="tooltip" data-placement="bottom"
  //                 title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN">
  //               </i>
  //             </div>
  //             <input name="secondBvn" onChange={formik.handleChange} value={formik.values.secondBvn} className="form-control bvn_input text-muted border-dark" type="text" id="bvn /"
  //               placeholder="Enter your BVN" />
  //             {formik.touched.secondBvn && formik.errors.secondBvn ? <small className="text-danger">{formik.errors.secondBvn}</small> : null}
  //           </div>

  //           <div className="row">
  //             <div className="col-sm-4 mt-4">
  //               <br/>
  //               <div className="col-12 pic_upload3 label_text3 text-nowrap">Photo</div>
  //             </div>

  //             <div className="col-sm-8 mt-4 pt-2 sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 sec">
  //                   <label htmlFor="firstname" className="label_text">Firstname</label>
  //                   <input name="secondFirstName" onChange={formik.handleChange} value={formik.values.secondFirstName} type="text" className="form-control bg-white border-dark" placeholder="" />
  //                   {formik.touched.secondFirstName && formik.errors.secondFirstName ? <small className="text-danger">{formik.errors.secondFirstName}</small> : null}
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="secondname" className="label_text">Secondname</label>
  //                   <input name="secondSecondName" onChange={formik.handleChange} value={formik.values.secondSecondName} type="text" className="form-control bg-white border-dark" placeholder="" />
  //                   {formik.touched.secondSecondName && formik.errors.secondSecondName ? <small className="text-danger">{formik.errors.secondSecondName}</small> : null}
  //                 </div>
  //               </div>
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6">
  //                   <label htmlFor="lastname" className="label_text">Lastname</label>
  //                   <input name="secondLastName" onChange={formik.handleChange} value={formik.values.secondLastName} type="text" className="form-control bg-white border-dark" placeholder="" />
  //                   {formik.touched.secondLastName && formik.errors.secondLastName ? <small className="text-danger">{formik.errors.secondLastName}</small> : null}
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="dateofbirth" className="label_text">Date of birth</label>
  //                   <input name="secondDateOfBirth" onChange={formik.handleChange} value={formik.values.secondDateOfBirth} type="date" className="form-control bg-white border-dark" placeholder="" />
  //                   {formik.touched.secondDateOfBirth && formik.errors.secondDateOfBirth ? <small className="text-danger">{formik.errors.secondDateOfBirth}</small> : null}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group">
  //             <label htmlFor="idcardtype" className="label_text mb-3">Select identity card type</label>

  //             <ul className="nav nav-pills identity-tab mb-3 nav-fill" id="pills-tab" role="tablist">
  //               {meansOfIdentification.map((identification: IMeansOfIdentification) => {
  //                 return (
  //                   <li className="nav-item" key={identification.id} onClick={() => handleSetSecondaryIdCardType(identification.id)}>
  //                     <a className={`nav-link text-nowrap pl-0 pt-2 ${identification.id == 1 ? "active" : ""}`} id="pills-int-tab" data-toggle="pill"
  //                       href="#pills-int" role="tab" aria-controls="pills-int" aria-selected="true">{identification.text}</a>
  //                   </li>
  //                 )
  //               })}
  //             </ul>
  //             <div className="tab-content" id="pills-tabContent">
  //               <div className="tab-pane show fade active" id="pills-int2" role="tabpanel"
  //                 aria-labelledby="pills-int-tab">
  //                 <div className="row mb-4">
  //                   <div className="col-md-6">
  //                     <div className="form-group">
  //                       <label htmlFor="nextofkin" className="label_text">ID card number</label>
  //                       <input name="secondIdCardNumber" onChange={formik.handleChange} value={formik.values.secondIdCardNumber} className="form-control border-dark" type="text" id="name"
  //                         placeholder="Enter ID card number" />
  //                       {formik.touched.secondIdCardNumber && formik.errors.secondIdCardNumber ? <small className="text-danger">{formik.errors.secondIdCardNumber}</small> : null}
  //                     </div>
  //                   </div>
  //                   <div className="col-md-3">
  //                     <div className="form-group identity">
  //                       <label htmlFor="issuedate" className="label_text">Issue Date</label>
  //                       <input name="secondIssueDate" onChange={formik.handleChange} value={formik.values.secondIssueDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" />
  //                     </div>

  //                   </div>
  //                   <div className="col-md-3">
  //                     <div className="form-group">
  //                       <label htmlFor="expirydate" className="label_text">Expiry Date</label>
  //                       <input name="secondExpiryDate" onChange={formik.handleChange} value={formik.values.secondExpiryDate} type="date" className="form-control border-dark bg-white" placeholder="dd/mm/yyyy" />
  //                     </div>

  //                   </div>
  //                 </div>

  //               </div>

  //             </div>

  //           </div>

  //           <div className="row">
  //             <div className="col sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 mr-2">
  //                   <label htmlFor="nextofkin" className="label_text">Name of next of kin</label>
  //                   <input name="secondNextOfKin" onChange={formik.handleChange} value={formik.values.secondNextOfKin} type="text" className="form-control bg-white border-dark"
  //                     placeholder="Enter name of next of kin"  />
  //                 </div>
  //                 <div className="col-lg-6 form-group">
  //                   <label htmlFor="employmentinformation" className="label_text text-nowrap">Select employment
  //                     information</label>
  //                     <select name="secondSelfEmploymentInformation" onChange={formik.handleChange} value={formik.values.secondSelfEmploymentInformation} onBlur={formik.handleBlur} className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
  //                       id="box">
  //                       {employmentInfos.map((employmentInfo: IEmploymentInfo) => {
  //                         return (
  //                           <option key={employmentInfo.id} value={employmentInfo.id}>{employmentInfo.name}</option>
  //                         )
  //                       })}
  //                     </select>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group mt-4">
  //             <label htmlFor="idcardtype" className="label_text font-weight-bold mb-3"><b>Joint account information</b></label>
  //             <div className="d-flex justify-content-between pb-2 fillup">
  //               <label htmlFor="name" className="label_text pb-1">Joint account name</label>
  //             </div>
  //             <input name="jointAccountName" onChange={formik.handleChange} value={formik.values.jointAccountName} className="form-control bvn_input text-muted border-dark" type="text" id="bvn" placeholder="" />
  //             {formik.touched.jointAccountName && formik.errors.jointAccountName ? <small className="text-danger">{formik.errors.jointAccountName}</small> : null}
  //           </div>

  //           <div className="row mt-4">
  //             <div className="col sec">
  //               <div className="row form-row mb-4">
  //                 <div className="col-lg-6 mr-2">
  //                   <label htmlFor="phonenumber" className="label_text">Joint account phone number</label>
  //                   <input name="jointPhoneNumber" onChange={formik.handleChange} value={formik.values.jointPhoneNumber} type="text" className="form-control border-dark bg-white" placeholder="0801 2345 678" />
  //                   {formik.touched.jointPhoneNumber && formik.errors.jointPhoneNumber ? <small className="text-danger">{formik.errors.jointPhoneNumber}</small> : null}
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="email" className="label_text"> Joint account email address</label>
  //                   <input name="jointEmailAddress" onChange={formik.handleChange} value={formik.values.jointEmailAddress} type="email" className="form-control bg-white border-dark" placeholder="" />
  //                   {formik.touched.jointEmailAddress && formik.errors.jointEmailAddress ? <small className="text-danger">{formik.errors.jointEmailAddress}</small> : null}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group mb-4">
  //             <label htmlFor="branch domicilation" className="label_text">Currencies of account to be
  //               opened</label>
  //               <select name="accountCurrencies" onChange={formik.handleChange} value={formik.values.accountCurrencies} className="form-control border-dark bg-white" id="">
  //                   <option value="">Select currency</option>
  //                   {currencies.map((currency: Icurrency) => {
  //                       return (
  //                           <option key={currency.id} value={currency.id}>{currency.brieF_DESC_ENG}</option>
  //                       )
  //                   })}
  //               </select>
  //           </div>

  //           <div className="row">
  //             <div className="col sec">
  //               <div className="row form-row mb-2">
  //                 <div className="col-lg-6 form-group mr-2">
  //                   <label htmlFor="employmentinformation" className="label_text">Select joint account mandate</label>
  //                   <select name="jointAccountMandate" onChange={formik.handleChange} value={formik.values.jointAccountMandate} onBlur={formik.handleBlur} className="form-control select-group border-dark bg-white select-dropdown pt-2 pb-3"
  //                     id="box">
  //                     <option value="">Select employment information</option>
  //                     {jointAccountMandate.map((mandate: IAccountMandate) => {
  //                       return (
  //                         <option key={mandate.id} value={mandate.id}>{mandate.mandate}</option>
  //                       )
  //                     })}
  //                   </select>
  //                   {formik.touched.jointAccountMandate && formik.errors.jointAccountMandate ? <small className="text-danger">{formik.errors.jointAccountMandate}</small> : null}
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="specifymandate" className="label_text">Specify Mandate (for others)</label>
  //                   <input name="jointMandateOthers" onChange={formik.handleChange} type="text" className="form-control bg-white border-dark" placeholder="" />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <label htmlFor="residentialaddress" className="label_text mb-2 font-weight-bold">Residential address</label>

  //           <div className="row">
  //             <div className="col sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 mr-2">
  //                   <label htmlFor="housenumber" className="label_text">House number</label>
  //                   <input name="houseNumber" onChange={formik.handleChange} value={formik.values.houseNumber} type="text" className="form-control bg-white border-dark" placeholder="No 12" />
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="streetname" className="label_text">Street name</label>
  //                   <input name="streetName" onChange={formik.handleChange} value={formik.values.streetName} type="text" className="form-control bg-white border-dark" placeholder="Bode Thomas" />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="row mb-4">
  //             <div className="col sec">
  //               <div className="row form-row mb-3">
  //                 <div className="col-lg-6 mr-2">
  //                   <label htmlFor="housenumber" className="label_text">Area/State</label>
  //                   <input name="areaState" onChange={formik.handleChange} value={formik.values.areaState} type="text" className="form-control bg-white border-dark" placeholder="Lagos" />
  //                 </div>
  //                 <div className="col-lg-6">
  //                   <label htmlFor="streetname" className="label_text">Nearest
  //                     bus-top/landmark</label>
  //                   <input name="nearestBustopLandmark" onChange={formik.handleChange} value={formik.values.nearestBustopLandmark} type="text" className="form-control bg-white border-dark" placeholder="Masha round about" />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="form-group mb-4">
  //             <label htmlFor="address" className="label_text">Address</label>
  //             <input name="address" onChange={formik.handleChange} value={formik.values.address} className="form-control sec border-dark" type="text" id="address"
  //               placeholder="No 12 Bode Thomas Masha round about Lagos" />
  //             {formik.touched.address && formik.errors.address ? <small className="text-danger">{formik.errors.address}</small> : null}
  //           </div>

  //           <div className="form-group">
  //             <label htmlFor="refferalcode" className="label_text">Referral code(optional)</label>
  //             <input name="referralCode" onChange={formik.handleChange} value={formik.values.referralCode} className="form-control border-dark" type="text" id="name" placeholder="Enter referral code" />
  //           </div>

  //           <div className="d-flex justify-content-end mt-4">
  //             <button style={{ marginRight: '10px' }} className="btn btn-outline-danger mr-3 btn-filled-white"
  //               >Previous</button>
  //             {updating ?
  //                 <div className="spinner-border text-danger" role="status">
  //                     <span className="sr-only"></span>
  //                 </div>:
  //                 <button type="submit" className="btn btn-danger btn-filled-red">Proceed</button>
  //             }
  //           </div>

  //         </div>

  //         </form>
  //     </div>

  // );
}

export default UpdateDetailJointCurrentDialog;
